import { MenuList, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import { StyledMenuPaper, StyledMenuItem } from './UserMenu.styles';

type UserMenuProps = {
  onLogout?: () => void;
};

export default function UserMenu({ onLogout }: UserMenuProps) {
  const { t } = useTranslation();
  const { logout, isLoading } = useAuth();

  const handleLogout = async (): Promise<void> => {
    try {
      await logout();
      onLogout?.();
    } catch (error) {
      onLogout?.();
    }
  };

  return (
    <StyledMenuPaper role='menu'>
      <MenuList disablePadding sx={{ p: 0 }}>
        <StyledMenuItem onClick={handleLogout} disabled={isLoading}>
          <Typography variant='body2' color='text.primary' sx={{ fontWeight: 500 }}>
            {isLoading ? t('auth.loggingOut') : t('auth.logout')}
          </Typography>
        </StyledMenuItem>
      </MenuList>
    </StyledMenuPaper>
  );
}
